<template>
  <div class="sp-template">
    <el-row :gutter="20">
      <el-col :span="7" >
        <el-card class="box-card" style="margin:0">
          <h2>2018年4月3号<span>星期二</span></h2>
          <span>上次登录时间：2018-04-01 20:20:20</span>
          <h2 class="m-t">你好！<span>迪哥</span></h2>
          <p>所属组织：深圳市星邮供应链管理有限公司</p>
          <p>所属部门：深圳IT部</p>
          <p>客户数量：1</p>
        </el-card>
      </el-col>
      <el-col :span="17" >
        <el-row :gutter="20">
          <el-col :span="d.icon == 'icon-yue' ? 10 : 8" v-for="(d, i) in styleArr" :key="i">
            <div class="f-box">
              <div class="f-img">
                <div class="f-img-bg" :class="d.bg">
                  <i class="iconfont" :class="d.icon"></i>
                </div>
              </div>
              <div class="f-c-box">
                <div class="f-content">
                  <h1><span v-if="d.icon == 'icon-yue'">¥&nbsp;</span>{{cardArr[i]}}</h1>
                  <span>{{d.text}}</span>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row class="m-t-20" :gutter="20">
      <el-col :span="12" >
        <el-card>
          <div slot="header" class="clearfix">
            <span class="h2">系统公告</span>
            <el-button style="float: right; padding: 3px 0" type="text">查看全部 >></el-button>
          </div>
          <ul class="news-list">
            <li class="list" v-for="o in 4" :key="o">
              <a href="#">{{'您有新的消息，请注意查收！ ' + o }}</a>
              <small class="small">2018-3-19</small>
              </li>
          </ul>
        </el-card>
      </el-col>
      <el-col :span="12" >
        <el-card>
          <div slot="header" class="clearfix">
            <span class="h2">最新消息</span>
            <el-button style="float: right; padding: 3px 0" type="text">查看全部 >></el-button>
          </div>
          <ul class="news-list">
            <li class="list" v-for="o in 4" :key="o">
              <a href="#">{{'您有新的消息，请注意查收！ ' + o }}</a>
              <small class="small">2018-3-19</small>
              </li>
          </ul>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cardArr: ['88', '66','88', '66', '99.99'],
      styleArr: [{
        bg: 'bg-c',
        icon: 'icon-sh-num',
        text: '今日收货订单数'
      },{
        bg: 'bg-o',
        icon: 'icon-ch-num',
        text: '今日出货订单数'
      },{
        bg: 'bg-b',
        icon: 'icon-sh-weight',
        text: '今日收货订单重量(吨)'
      },{
        bg: 'bg-b',
        icon: 'icon-ch-weight',
        text: '今日出货订单重量(吨)'
      },{
        bg: 'bg-b',
        icon: 'icon-yue',
        text: '今日收货订金额'
      }]
    }
  },
  components: {
  },
  mounted: function () {
  	var _this = this
    this.$nextTick(function () {
    })
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.box-card{
  * + *{
    margin-top: 10px;
  }
  h2{
    font-weight: normal;
  }
  span{
    display: inline-block;
  }
  .m-t{
    margin-top: 56px;
    margin-bottom: 40px;
  }
}
.f-box{
  margin-bottom: 20px;
}
//新闻
.news-list{
  .list{
    padding: 15px 0;
    & + .list{
      border-top: 1px solid #ebeef5;
    }
  }
  .small{
    float: right;
    color: #888;
    font-size: 12px;
  }
}

.clearfix{
  .h2{
    font-size: 16px;
    font-weight: bold;
    color: #666;
  }
}

@media (min-width: 768px){
}
@media (min-width: 992px){
}
</style>


// WEBPACK FOOTER //
// src/views/home/index.vue